import RA from 'ra-config'

export function getStrategyChartTitle({ query, region, activeAggregate }) {
  let title = forStrategyDefault(region ? region.value : '')

  if (activeAggregate) {
    title = forStrategy(region, activeAggregate)
  } else if (query.category) {
    title = forStrategyCategory(region, query.category)
  }

  return title
}

export function getFactorChartTitle({ query, region, activeAggregate }) {
  let title = forFactorDefault(region ? region.value : '')

  if (activeAggregate) {
    title = forFactor(region, activeAggregate)
  } else if (query.category) {
    title = forFactorCategory(region, query.category)
  }

  return title
}

export function forStrategyDefault(region) {
  return prependRegion(region, RA.app.strategies.longName)
}

export function forFactorDefault(region) {
  return prependRegion(region, RA.app.factors.longName)
}

export function forStrategyCategory(region, category) {
  let categoryLabel = getCategoryLabel(RA.app.strategies.categoryList, category)
  return prependRegion(region, categoryLabel)
}

export function forFactorCategory(region, category) {
  let categoryLabel = getCategoryLabel(RA.app.factors.categoryList, category)
  return prependRegion(region, categoryLabel)
}

export function forStrategy(region, strategy) {
  let r = region == null ? '' : strategy.Region
  return prependRegion(r, strategy.Name + ' Strategy')
}

export function forFactor(region, factor) {
  let r = region == null ? '' : factor.Region
  return prependRegion(r, factor.Name + ' (' + factor.Category + ') Factor')
}

function prependRegion(region, title) {
  return `${getRegionLabel(region)} ${title}`.trim()
}

function getRegionLabel(region) {
  let regionItem = RA.app.page.regionOptionList.find(r => r.value === region)
  if (regionItem) {
    return regionItem.longName
  }
  return ''
}

function getCategoryLabel(list, category) {
  let categoryItem = list.find(c => c.name === category)
  if (categoryItem) {
    return categoryItem.longName
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/config/viewing-label.js